import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { DiscountedProductsWithPackagesResponse } from '../../shared/discounted-products-with-packages.response';

@Injectable({
    providedIn: 'root'
})
export class GetDiscountedProductsWithPackagesUseCase extends UseCase<{}, Observable<DiscountedProductsWithPackagesResponse>> {
    discountedProductsWithPackagesUrl = '/store/getDiscountedProductsWithPackages';

    storeBackendUrl = '';

    constructor(
        private _apiRequestService: ApiRequestService,
        @Inject('STORE_BACKEND_URL') private _storeBackendUrl: string,
        _logService: LogService,
        protected override _http: HttpClient
    ) {
        super(_logService, _http);
        this.storeBackendUrl = _storeBackendUrl;
    }

    protected override executeBusinessLogic(
        request: void | {}
    ): void | Observable<DiscountedProductsWithPackagesResponse> {
        return this._apiRequestService.sendRequest(this.storeBackendUrl, request, true, this.discountedProductsWithPackagesUrl);
    }
}
